import DefaultModal from '@/ui/modals/defaultModal';
import logo from '@/assets/logo.svg';
import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';

interface SubscriptionCTAModalProps {
  open?: boolean;
  onClose?: () => void;
}

const SubscriptionCTAModal = ({ open = false, onClose = () => {} }: SubscriptionCTAModalProps) => {
  const [t] = useTranslation('analytics');

  useEffect(() => {
    if (open) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }

    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [open]);

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative" onClose={onClose}>
        <TransitionChild
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" style={{ zIndex: 1000 }} />
        </TransitionChild>

        <div className="fixed inset-0 overflow-y-auto" style={{ zIndex: 1000 }}>
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="max-w-md w-full transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all p-5">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img src={logo} width="35px" />
                  <div className="ml-2">ESG LENS</div>
                </div>
                <div style={{ marginLeft: '4px' }}>
                  <div className="text-text-200">AI-Powered ESG Insights</div>
                </div>

                <div className="mt-4">
                  <div className="mt-4">
                    <div>
                      <div>{t('Need Advanced ESG Analytics?')}</div>
                    </div>
                    <div>
                      <div className="text-text-200">
                        {t('Please contact to FairLabs team and upgrade your subscription.')}
                      </div>
                    </div>
                  </div>
                  <div className="my-8 mx-4 space-y-4">
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <div>{t('ESG Data analysis')}</div>
                    </div>
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <div>{t('ESG Index analysis')}</div>
                    </div>
                    <div className="flex items-center">
                      <Check className="w-4 h-4 mr-2 text-main" />
                      <div>{t('Stock Data analysis')}</div>
                    </div>
                  </div>
                </div>

                <div style={{ marginBottom: '8px' }}>
                  <Button
                    className="w-full bg-main"
                    onClick={() => window.open('https://www.fairlabs.io/contact', '_blank')}
                  >
                    {t('Contact us')}
                  </Button>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default SubscriptionCTAModal;
